/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ManagerProjectOverviewController', ManagerProjectOverviewController);

    ManagerProjectOverviewController.$inject = ['$timeout', '$scope', '$http', 'entity'];

    function ManagerProjectOverviewController ($timeout, $scope, $http, entity) {
        var vm = this;
        console.log(entity);
        vm.profile = entity;
        vm.projects = [];
        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/manager/' + vm.profile.id, {}).then(function (response) {
                vm.projects = response.data;
            });
        }
    }
})();
